import { observer } from 'mobx-react-lite'
import { Collapse } from '@mui/material'
import { useSkillAssessmentStore } from '../../../skill-assessment/store/skill-assessment.store'
import { useEffect, useState } from 'react'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'
import { SkillCategoryList } from './SkillCategoryList'
import { MyLearningMetrics } from '../organism/myLearningMetrics'

/**
 * Main component for displaying skill gap analysis
 * Fetches skill categories and manages display state
 */
export const SkillGapAnalysis = observer(() => {
  const { translation } = useLocalizationStore()
  const skillAssessmentStore = useSkillAssessmentStore()

  const translations = translation.pages.myTeam
  const [open, setOpen] = useState<boolean>(false)

  useEffect(() => {
    skillAssessmentStore.reset()
    skillAssessmentStore.getSkillSets().then(() => {
      if (skillAssessmentStore.skillSets && skillAssessmentStore.skillSets.length > 0) {
        const hasSkills = skillAssessmentStore.skillSets.some(category => category.skills?.length > 0)

        setOpen(hasSkills)
      } else {
        setOpen(false)
      }
    })
  }, [skillAssessmentStore])

  return (
    <>
      {skillAssessmentStore.skillSets && skillAssessmentStore.skillSets.length > 0 && <MyLearningMetrics />}
      <Collapse in={open} timeout={500} mountOnEnter unmountOnExit>
        {skillAssessmentStore.skillSets && (
          <SkillCategoryList
            categories={skillAssessmentStore.skillSets}
            errorMessage={translations.errorMsg.rateAllSkills()}
          />
        )}
      </Collapse>
    </>
  )
})